import { Navigate, useNavigate } from "react-router-dom";
import { IconClockHour4, IconMail, IconLogout, IconCircleCheck } from "@tabler/icons-react";
import { Card } from "@/components/ui/card";
import { isMockEnabled } from "@/lib/mock-flags";
import { useAuthStore } from "@/features/auth/stores/authStore";
import { OnboardingShell } from "../components/OnboardingShell";

export function PendingApprovalPage() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const patchUser = useAuthStore((s) => s.patchUser);
  const logout = useAuthStore((s) => s.logout);

  if (!user) return <Navigate to="/login" replace />;
  // Backstop: precisa ter concluído perfil + termos antes de aguardar aprovação.
  if (!user.profileCompleted) return <Navigate to="/onboarding/agency-profile" replace />;
  if (!user.termsAccepted) return <Navigate to="/onboarding/terms" replace />;
  // Já aprovada → painel.
  if (user.approvalStatus === "approved") return <Navigate to="/dashboard" replace />;

  function handleLogout() {
    // logout() revoga o cookie HttpOnly `rt` no backend e limpa o estado local.
    void logout();
    navigate("/login", { replace: true });
  }

  const rejected = user.approvalStatus === "rejected";

  return (
    <OnboardingShell activeStep={3}>
      <Card className="p-8 text-center shadow-card border-border/60">
        <div
          className={`mx-auto mb-5 grid h-16 w-16 place-items-center rounded-2xl ${
            rejected ? "bg-danger-soft text-danger" : "bg-warning-soft text-warning-ink"
          }`}
        >
          <IconClockHour4 size={30} />
        </div>

        <h1 className="text-xl font-bold tracking-tight text-ink">
          {rejected ? "Cadastro não aprovado" : "Cadastro enviado para análise"}
        </h1>
        <p className="mx-auto mt-2 max-w-sm text-sm text-ink-muted">
          {rejected ? (
            <>
              Não foi possível aprovar o cadastro da <strong>{user.name}</strong>. Entre em contato
              com o suporte do ImobGo para entender os próximos passos.
            </>
          ) : (
            <>
              Recebemos os dados da sua imobiliária. Nossa equipe vai revisar e liberar o acesso ao
              portal. Você será avisado por e-mail assim que for aprovado.
            </>
          )}
        </p>

        {!rejected && (
          <div className="mt-6 flex items-center justify-center gap-2 rounded-xl border border-border bg-bg px-4 py-3 text-[13px] text-ink-muted">
            <IconMail size={16} className="text-brand-600" />
            Aviso será enviado para <span className="font-medium text-ink">{user.email}</span>
          </div>
        )}

        <button
          type="button"
          onClick={handleLogout}
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl border border-border py-3 text-sm font-medium text-ink transition-colors hover:bg-gray-50"
        >
          <IconLogout size={16} />
          Sair
        </button>

        {/* Atalho só de demonstração: simula a aprovação pelo backoffice. */}
        {isMockEnabled("agency") && (
          <button
            type="button"
            onClick={() => {
              patchUser({ approvalStatus: "approved" });
              navigate("/dashboard", { replace: true });
            }}
            className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-xl border border-dashed border-brand-400 py-2.5 text-[12px] font-medium text-brand-700 transition-colors hover:bg-brand-50"
          >
            <IconCircleCheck size={15} />
            Simular aprovação (demo)
          </button>
        )}
      </Card>
    </OnboardingShell>
  );
}
